import { Table, Typography } from '@equinor/eds-core-react'
import AsyncResource from '../../../../components/async-resource/async-resource'
import { VulnerabilitySummary } from '../../../../components/vulnerability-summary'
import type { Component } from '../../../../store/radix-api'
import { useGetEnvironmentVulnerabilitySummaryQuery } from '../../../../store/scan-api'
import { getFetchErrorMessage, getScanStatus } from './vulnerabilitySummaryCell.utils'

interface VulnerabilitySummaryCellProps {
  readonly appName: string
  readonly envName: string
  readonly componentName: string
  readonly componentType: Component['type']
}

export const VulnerabilitySummaryCell = (props: VulnerabilitySummaryCellProps) => {
  const { appName, envName, componentName, componentType } = props

  const { data: vulnerabilities, error, isLoading } = useGetEnvironmentVulnerabilitySummaryQuery({ appName, envName })
  const asyncState = { isLoading, isError: !!error, error }

  const scan =
    componentType === 'job' ? vulnerabilities?.jobs?.[componentName] : vulnerabilities?.components?.[componentName]
  const scanStatus = getScanStatus(scan)

  return (
    <Table.Cell>
      <AsyncResource
        asyncState={asyncState}
        errorContent={<samp>{asyncState.isError && getFetchErrorMessage(asyncState.error)}</samp>}
      >
        {scan?.scanSuccess ? (
          <VulnerabilitySummary summary={scan.vulnerabilitySummary} />
        ) : (
          <Typography group="table" variant="cell_text" color={scanStatus.color}>
            {scanStatus.label}
          </Typography>
        )}
      </AsyncResource>
    </Table.Cell>
  )
}
